import { useTranslation } from "react-i18next";
import SectionTitle from "../sectionTitle";
import { CaseCard } from "./components/CasesCard";
import style from'./style.module.scss'


export function UseCases() {
    const { t } = useTranslation()

    const topCases = t('useCases.topCases', { returnObjects: true})
    const bottomCases = t('useCases.bottomCases', { returnObjects: true })

    return (
        <section id='use-cases' className={`${style['use']}`}>
            <div className={`container section ${style['use__container']}`}>
                <SectionTitle
                    label={t('useCases.label')}
                    title={t('useCases.title')}
                />

                <div className={style["use__cards"]}>
                    <div className={style["use__cards-top"]}>
                        {topCases.map((item, i) => (
                            <CaseCard key={i} {...item} />
                        ))}
                    </div>

                    <div className={style["use__cards-bottom"]}>
                        {bottomCases.map((item, i) => (
                            <CaseCard key={i} {...item} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}